import React from "react";
import { ArrowDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
export default function Blkn() {
  return <section id="blkn" className="dark bg-background text-foreground relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden px-4 py-20">
      {}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-15 mix-blend-overlay" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='1'/%3E%3C/svg%3E")`,
      backgroundRepeat: "repeat"
    }} />

      {}
      <div className="relative z-10 flex flex-col items-center justify-center text-center perspective-[1000px]">
        {}
        <h1 className="select-none">
          <img src="https://blkn.com.au/wp-content/uploads/2026/03/BLKN-Logo-White-Marginised.png" alt="BLKN Logo" className="object-contain !h-[500px] !w-[800px]" style={{
          filter: "drop-shadow(0 20px 50px rgba(0,0,0,0.5))"
        }} />
        </h1>

        {}
        
      </div>

      {}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 animate-bounce">
        <Link to="#about" aria-label="Scroll down">
          <ArrowDown className="h-10 w-10 text-white opacity-80 hover:opacity-100 transition-opacity" />
        </Link>
      </div>
    </section>;
}